import analytics from '../index';

async function trackLinkClicks(fieldId, fieldName, linkTarget) {
  const linkClickPayload = {
    field_id:    fieldId,
    field_name:  fieldName,
    link_target: linkTarget,
  };

  await analytics.track('linkClicked', linkClickPayload);
}

function handleClickEvent(e) {
  const { target } = e;
  const { id, name, href } = target;

  trackLinkClicks(id, name, href);
}

function addLinkClickEventListeners() {
  const inputs = document.getElementsByTagName('a');

  for (let i = 0; i < inputs.length; i += 1) {
    inputs[i].addEventListener('click', handleClickEvent);
  }
}

function removeLinkClickEventListeners() {
  const inputs = document.getElementsByTagName('a');

  for (let i = 0; i < inputs.length; i += 1) {
    inputs[i].removeEventListener('click', handleClickEvent);
  }
}

export {
  addLinkClickEventListeners,
  removeLinkClickEventListeners,
  handleClickEvent,
};
